var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotif08(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 15.9955,
    viewBox: "0 0 32 15.9955",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32 0C32 8.8339 24.8365 15.9953 16 15.9953V0H32Z",
    fill: "#D4623A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 15.9955C7.16336 15.9955 0 8.83402 0 0.000117478H16V15.9955Z",
    fill: "#274766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16 8.16314C11.4902 8.16314 7.83447 4.50845 7.83447 0H16V8.16314Z",
    fill: "#86905B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif08);
export default __webpack_public_path__ + "static/media/motif-08.3c31d99c8563a11c9f50599becd0656e.svg";
export { ForwardRef as ReactComponent };